import axios from 'axios'
import { GET_CATEGORY, GET_CATEGORY_STORE } from '@/constants/path'
import store from '@/store'

const ignoreErrorPath = [GET_CATEGORY, GET_CATEGORY_STORE]

export default function setup() {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL

  axios.interceptors.request.use(
    function (config) {
      config.headers.Accept = '*/*'
      const token = store?.getters['auth/token'] ?? ''
      if (token) {
        config.headers.Authorization = `Com7-JWT ${token}`
      }
      return config
    },
    function (err) {
      return Promise.reject(err)
    },
  )
}

export const api = async (path, method, param, options) => {
  if (path.includes('/report/')) {
    // console.log('if', path)
    axios.defaults.baseURL = process.env.VUE_APP_REPORT_URL
  } else {
    // console.log('else', path)
    axios.defaults.baseURL = process.env.VUE_APP_API_URL
  }

  const met = method.toLowerCase()
  try {
    if (met === 'get') {
      return await axios.get(path, param, options)
    } else if (met === 'post') {
      return await axios.post(path, param, options)
    }
  } catch (e) {
    if (401 === e.response.status) {
      store.dispatch('auth/logout')
    } else {
      if (
        !ignoreErrorPath.find((i) =>
          i.toLowerCase().includes(`${path}`),
        )
      ) {
        const isJsonBlob = (data) =>
          data instanceof Blob && data.type === 'application/json'
        const responseData = isJsonBlob(e.response?.data)
          ? await e.response?.data?.text()
          : e.response?.data || {}
        const responseJson =
          typeof responseData === 'string'
            ? JSON.parse(responseData)
            : responseData
        if (isJsonBlob(e.response?.data)) {
          store.commit(
            'error/SET_MESSAGE',
            responseJson.error ?? 'ไม่พบข้อมูล',
          )
        } else {
          store.commit(
            'error/SET_MESSAGE',
            e.response.data.error ?? 'ไม่พบข้อมูล',
          )
        }

        store.commit('error/SET_TOAST', true)
      }
    }
    return Promise.reject(e)
  }
}
